var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "placeholder-vue header-placeholder" }, [
      _c("div", { staticClass: "placeholder-nav-section left-placeholder" }, [
        _c("div", { staticClass: "placeholder-bar name-placeholder" }),
        _vm._v(" "),
        _c("div", { staticClass: "placeholder-bar points-placeholder" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "placeholder-nav-section center-placeholder" }, [
        _c("div", { staticClass: "placeholder-bar location-placeholder" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "placeholder-nav-section right-placeholder" }, [
        _c("div", { staticClass: "placeholder-bar cart-placeholder" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdfcd0d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdfcd0d8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderPlaceholder.vue
// module id = null
// module chunks = 